module.exports = __webpack_public_path__ + "img/co.9af3b763.png";